<template>
  <div>
    <ModalComponent ref="dialog" @closed="onModalClosed">
      <template #titleText>
        <!-- <div class="max-w-full w-[450px] text-center">{{ title }}</div> -->
      </template>
      <template #subtitleText>
        <div class="relative">
          <div
            class="absolute w-full text-center text-black z-[2] text-xl top-3 ripple"
            @click="copyUssdCode"
          >
            {{ ussdCode }}
          </div>
          <div
            class="w-full mx-auto -mb-[calc(5vw+50vw)]"
            style="mask-image: linear-gradient(to top, #0000 50vw, #fff)"
          >
            <img
              src="@/assets/images/all/phoneComposer.webp"
              class="object-cover w-full object-top rounded-2xl"
            />
          </div>
        </div>
      </template>
      <div class="max-h-[60vh]">
        <div class="text-3xl font-bold text-center">{{ title }}</div>
        <div class="py-2"></div>
        <div class="flex flex-col gap-6 px-2 text-lg text-left">
          <div v-for="(instruction, i) in instructions" :key="i">
            <div v-if="instruction.type == 'double'">
              <div v-if="instruction.text">
                <span v-html="instruction.text"></span>
              </div>
              <div class="grid grid-cols-2 gap-8 relative">
                <div
                  class="absolute w-full flex h-full justify-center items-center pointer-events-none"
                >
                  <div class="absolute h-1/4 -translate-y-full border-l"></div>
                  <div class="absolute h-1/4 translate-y-full border-l"></div>
                  <div class="text-sm">Ou</div>
                </div>
                <div
                  v-for="(option, j) in [
                    instruction.option1,
                    instruction.option2,
                  ]"
                  :key="j"
                >
                  <div
                    is="option.action == 'tel' ? 'a' : 'div'"
                    class="leading-[0.8lh] text-sm bg-none px-2 py-5 border buttonComponent block justify-center mt-1 w-full"
                    href="`tel:${option.actionContent}`"
                    @click="onInstructionClicked(option)"
                  >
                    <span>
                      <span v-html="option.text"> </span>
                    </span>
                    <span class="ml-2">
                      <!-- &nbsp; -->
                      <img
                        src="@/assets/images/all/phone-call-white.svg"
                        class="w-[1em] h-[1em] inline-block -mt-[3px]"
                        alt=""
                        v-if="option.action == 'tel'"
                      />
                      <img
                        v-else-if="option.action == 'copy'"
                        src="@/assets/images/all/copy-white.svg"
                        class="w-[1em] h-[1em] inline-block -mt-[3px]"
                        alt=""
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else
              is="instruction.action == 'tel' ? 'a' : 'div'"
              href="`tel:${instruction.actionContent}`"
              :class="{ ripple: instruction.action }"
              class="px-0"
              @click="onInstructionClicked(instruction)"
            >
              <span v-html="instruction.text"> </span>
              <span
                v-if="instruction.action == 'copy'"
                class="ml-2 relative -top-1"
              >
                <img
                  src="@/assets/images/all/copy-white.svg"
                  class="w-5 h-5 inline"
                  alt=""
                />
              </span>
            </div>
          </div>
        </div>
        <div class="py-4"></div>
        <FormComponent
          class="w-full"
          :fields="formFields"
          :onFormSubmited="onFormSubmited"
          :loading="false"
          ref="form"
        >
          <template #submitButton>
            <div class="grid grid-cols-1 gap-6">
              <!-- <a
                class="bg-none border buttonComponent flex justify-center mt-4 w-full"
                :href="`tel:${ussdCode}`"
              >
                <span>
                  <img
                    src="@/assets/images/all/phone-call-white.svg"
                    class="w-4 h-4 inline"
                    alt=""
                  />
                  &nbsp;
                </span>
                <span> Lancer </span>
              </a> -->
              <button class="buttonComponent mt-4 w-full" type="submit">
                Continuer
              </button>
            </div>
          </template>
        </FormComponent>
      </div>
    </ModalComponent>
  </div>
</template>

<script>
import FormComponent from '@/components/utils/FormComponent.vue'
import ModalComponent from '@/components/utils/ModalComponent.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TransactionLaunchedListener',
  components: { ModalComponent, FormComponent },
  props: {},
  data() {
    return {
      instructions: [],
      requiredFields: [],
      title: '',
      ussdCode: '',
      formFields: [
        {
          type: 'text',
          propertyName: 'whatsappNumber',
          label: this.$t('register.whatsappInputLabel'),
          defaultValue: '',
          required: false,
          class: 'col-span-12',
        },
      ],
      transactionData: {},
    }
  },
  mounted() {
    this.loadManualInformationNotResolved()
  },
  beforeUnmount() {},
  methods: {
    test() {
      const data = {
        operator: 'MOOV',
        country: 'GA',
        title: 'Transférez 5000 FCFA',
        instructions: [
          {
            text: 'Etape 1 : Tapez le code USSD suivant',
            type: 'double',
            option1: {
              text: 'Cliquez & Lancez  *555*3*01#',
              actionContent: '*555*3*01#',
              action: 'tel',
            },
            option2: {
              text: 'Cliquez & Copiez  *555*3*01#',
              actionContent: '*555*3*01#',
              action: 'copy',
            },
          },
          {
            text: 'Etape 2 : Entrez maintenant le code agent suivant : <span class="underline">RA6509</span>',
            actionContent: 'RA6509',
            action: 'copy',
          },
          {
            text: 'Etape 3 : Entrez la référence de transaction dans le champ ci-dessous',
            actionContent: '',
            action: '',
          },
        ],
        requiredFields: [
          {
            label: 'ID ou REF de la transaction',
            placeHolder: 'xxxxxxxxx',
            type: 'text',
          },
        ],
      }
      this.getManualOperationData(data)
    },
    getManualOperationData(instructionsData, transactionData) {
      this.title = instructionsData.title
      this.ussdCode = instructionsData.ussdCode
      this.instructions = instructionsData.instructions
      this.requiredFields = instructionsData.requiredFields
      this.formFields = this.generateFormFields(instructionsData.requiredFields)
      this.$refs.dialog.show()
      this.transactionData = transactionData
      this.$QuickStorage.storeData('unresolvedManualInfoGetting', {
        instructionsData,
        transactionData,
      })
    },
    onModalClosed() {
      console.log('will unsore unresolvedManualInfoGetting')
      this.$QuickStorage.removeStored('unresolvedManualInfoGetting')
    },
    loadManualInformationNotResolved() {
      const unresolvedManualInfoGetting = this.$QuickStorage.getStored(
        'unresolvedManualInfoGetting',
      )
      console.log(unresolvedManualInfoGetting)
      if (!unresolvedManualInfoGetting) return
      const { instructionsData, transactionData } = unresolvedManualInfoGetting
      this.getManualOperationData(instructionsData, transactionData)
    },
    generateFormFields(fields) {
      return fields.map(field => {
        return {
          type: field.type,
          propertyName: field.label,
          label: field.label,
          placeHolder: field.placeHolder,
          defaultValue: '',
          required: true,
        }
      })
    },
    copyUssdCode() {
      this.$Commons.copy(this.ussdCode)
    },
    async onInstructionClicked(instruction) {
      if (!instruction.action) return
      if (instruction.action == 'tel') {
        if (self !== top) {
          const res = await this.$Events.sendDataRequestResolve('execCode', {
            functionPathString: 'window.open',
            args: [
              `tel:${instruction.actionContent.replace(/#/g, '%23')}`,
              '_system',
            ],
          })
          console.log(res)
        } else {
          window.top.location.href = `tel:${instruction.actionContent.replace(/#/g, '%23')}`
        }
        /*

        const code = `window.parent.open('tel:${instruction.actionContent}', '_blank')`
        this.$Events.dispatchEvent('evaluate_in_parent', { code })
         */
        return
      }
      if (instruction.action == 'copy')
        this.$Commons.copy(instruction.actionContent)
    },
    async onFormSubmited(data) {
      this.$refs.dialog.hide()
      await new Promise(r => setTimeout(r, 500))
      this.$emit('manualInfoFilled', {
        manualCollectInfos: data,
        transactionData: this.transactionData,
      })
      this.transactionData = null
    },
  },
})
</script>
